export default "__VITE_ASSET__e114f589__"